import { render, staticRenderFns } from "./CatalogView.vue?vue&type=template&id=664bbab3"
import script from "./CatalogView.vue?vue&type=script&lang=js"
export * from "./CatalogView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports